import { H2 } from '@blueprintjs/core';
import * as React from 'react';

import { NewProjectButton } from 'src/containers/Home/NewProjectButton';
import * as copy from 'src/templates/copy';

export const EmptyHome: React.VFC = () => {
  return (
    <div className="sd-home-no-projects">
      <H2>{copy.components.home.noProjects}</H2>
      {copy.components.home.noProjectsText}
      <NewProjectButton isImportAllowed={false} />
    </div>
  );
};
